export default __webpack_public_path__ + "static/media/Akbar.637f1ce6.png";